/**
 * @file useRecentFonts.ts
 * @description «Недавние» шрифты окна «Шрифт элемента» текущего магазина
 * (phase19.16, партия SB120; uiux-sb120-fields §4): до 6 ключей на
 * устройстве, `commora.recent.fonts.<shopId>`. Магазин — из активного
 * кабинета (`useActiveShopId`); вне провайдера — общая память без магазина.
 *
 * Список читается из хранилища при монтировании — хук стоит в содержимом
 * окна (`FontQuickPicks`), которое монтируется при каждом открытии. Поэтому
 * выбор в одном поле «Шрифт» виден в «Недавних» другого поля той же панели
 * при следующем открытии окна: копии с монтирования поля нет. Поле само
 * только запоминает выбор (`remember`).
 */

import { useCallback, useState } from "react";

import { useActiveShopId } from "./useActiveShopId";
import { pushRecentFont, readRecentFonts } from "../../lib/site-fields/recent-memory";

export interface RecentFontsApi {
  /** Ключи шрифтов на момент монтирования, новое — первым. */
  recent: string[];
  /** Запомнить шрифт: новое — в начало, без повторов. */
  remember: (key: string) => void;
}

export function useRecentFonts(): RecentFontsApi {
  const shopId = useActiveShopId();
  const [recent, setRecent] = useState(() => readRecentFonts(shopId));
  const remember = useCallback((key: string) => setRecent(pushRecentFont(shopId, key)), [shopId]);
  return { recent, remember };
}
